import React, { useState } from 'react';
import Navbar from "./Navbar";

// Colors matching your OCD Serenity app
const Colors = {
  primary: '#4caf50',
  secondary: '#f09a73',
  background: '#2e2e2e',
  tile: '#1e1e1e',
  text: '#ffffff',
  textSecondary: '#aaaaaa',
  border: '#444444',
  input: '#575656',
  danger: '#fa6161',
  success: '#61fa69',
  warning: '#faf261',
  buttonText: '#ffffff',
  premium: '#9B7EDE',
  premiumGradientStart: '#7B5CD6',
  premiumGradientEnd: '#B79FE7'
};

// Icon component - replace with your preferred icon library
const Icon = ({ name, size = 24, color = Colors.primary, style = {} }) => {
  const iconMap = {
    'account': '👤',
    'medical-bag': '🏥',
    'brain': '🧠',
    'hospital-building': '🏥',
    'office-building': '🏢',
    'domain': '🏛️',
    'check-circle': '✅',
    'school': '🎓',
    'flask': '🧪',
    'link-variant': '🔗',
    'chevron-right': '▶️',
    'rocket': '🚀'
  };
  
  return (
    <span style={{ fontSize: size, color, ...style }}>
      {iconMap[name] || '📋'}
    </span>
  );
};

const ProfessionalPricingScreen = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [billingCycle, setBillingCycle] = useState('monthly');

  const practitionerPlans = [
     {
      id: 'free',
      name: 'Free Starter',
      monthlyPrice: 0,
      annualPrice: 0,
      description: 'Perfect for individual therapists',
      features: [
        'Up to 3 active patients',
        'Patient progress monitoring',
        'Global HIPAA-secure client database',
        'Secure client messaging',
        'Email support'
      ],
      icon: 'account',
      popular: false
    },
    {
      id: 'starter',
      name: 'Professional Starter',
      monthlyPrice: 75,
      annualPrice: 756,
      description: 'Perfect for OCD specialists',
      features: [
        'Up to 10 active patients',
        'Custom feature development',
        'Custom reporting dashboard',
        'Dedicated HIPAA-secure client database',
        'Secure client messaging',
        'Priority Email support'
      ],
      icon: 'account',
      popular: false
    },
    {
      id: 'professional',
      name: 'Professional Plus',
      monthlyPrice: 195,
      annualPrice: 1944,
      description: 'For centers, clinics and organizations',
      features: [
        'Unlimited practitioner licenses',
        'Complete white-label solution',
        'Custom feature development',
        'Custom reporting dashboard',
        'Dedicated HIPAA-secure client database',
        'Unlimited active patients',
        'Secure client messaging',
        'Priority support'
      ],
      icon: 'medical-bag',
      popular: false
    }
  ];

  


  const handleSelectPlan = (plan, type) => {
    setSelectedPlan({ ...plan, type });
    alert(`Selected: ${plan.name} (${type})`);
  };

  const handleContactSales = () => {
  const email = 'contact@ocdserenity.com';
  const subject = 'Plan Subscription Inquiry';
  
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  
  window.open(mailtoLink, '_blank');
};

  const handleStartTrial = (plan) => {
    alert(`Starting 30-day free trial of ${plan.name}. No credit card required.`);
  };

  const PricingCard = ({ plan, type, onSelect, onTrial }) => {
    const currentPrice = billingCycle === 'monthly' ? plan.monthlyPrice : plan.annualPrice;
    const savings = billingCycle === 'annual' ? plan.monthlyPrice - (plan.annualPrice/12) : 0;
    
    return (
      <div style={{
        backgroundColor: Colors.tile,
        borderRadius: '16px',
        padding: '20px',
        minWidth: '320px',
        maxWidth: '320px',
        border: plan.popular ? `2px solid ${Colors.primary}` : `2px solid ${Colors.border}`,
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        position: 'relative',
        flexShrink: 0,
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        transform: plan.popular ? 'scale(1.05)' : 'scale(1)',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = plan.popular ? 'scale(1.08)' : 'scale(1.03)';
        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = plan.popular ? 'scale(1.05)' : 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
      }}>
        {plan.popular && (
          <div style={{
            position: 'absolute',
            top: '-10px',
            left: '20px',
            right: '20px',
            background: `linear-gradient(135deg, ${Colors.primary}, ${Colors.secondary})`,
            padding: '6px',
            borderRadius: '12px',
            textAlign: 'center'
          }}>
            <span style={{
              fontSize: '12px',
              fontWeight: 'bold',
              color: Colors.buttonText
            }}>MOST POPULAR</span>
          </div>
        )}
        
        <div style={{
          textAlign: 'center',
          marginBottom: '20px',
          marginTop: '10px'
        }}>
          <Icon 
            name={plan.icon} 
            size={40} 
            color={Colors.primary}
            style={{ marginBottom: '15px' }}
          />
          <h3 style={{
            fontSize: '20px',
            fontWeight: 'bold',
            color: Colors.text,
            margin: '12px 0 4px'
          }}>{plan.name}</h3>
          <p style={{
            fontSize: '14px',
            color: Colors.textSecondary,
            margin: '0 0 4px'
          }}>{plan.description}</p>
          {plan.practitioners && (
            <span style={{
              fontSize: '12px',
              color: Colors.primary,
              fontWeight: '600',
              backgroundColor: Colors.primary + '20',
              padding: '4px 8px',
              borderRadius: '8px',
              marginTop: '4px',
              display: 'inline-block'
            }}>{plan.practitioners} practitioners</span>
          )}
        </div>

        <div style={{
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          <span style={{
            fontSize: '36px',
            fontWeight: 'bold',
            color: Colors.text
          }}>${currentPrice}</span>
          <span style={{
            fontSize: '16px',
            color: Colors.textSecondary
          }}>/{billingCycle}</span>
          {savings > 0 && (
            <div>
              <span style={{
                fontSize: '12px',
                color: Colors.success,
                fontWeight: '600',
                backgroundColor: Colors.success + '20',
                padding: '4px 8px',
                borderRadius: '8px',
                marginTop: '4px',
                display: 'inline-block'
              }}>Save ${savings}/month</span>
            </div>
          )}
        </div>

        <div style={{ marginBottom: '20px' }}>
          {plan.features.map((feature, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '8px'
            }}>
              <Icon name="check-circle" size={16} color={Colors.success} />
              <span style={{
                fontSize: '14px',
                color: Colors.text,
                marginLeft: '8px',
                lineHeight: '20px'
              }}>{feature}</span>
            </div>
          ))}
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          
          
          
        </div>
      </div>
    );
  };

  const ValueAddedCard = ({ option }) => {
    return (
      <div style={{
        backgroundColor: Colors.tile,
        borderRadius: '12px',
        padding: '20px',
        margin: '0 20px 16px',
        border: `1px solid ${Colors.border}`,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '12px'
        }}>
          <Icon 
            name={option.icon} 
            size={32} 
            color={Colors.primary}
            style={{ marginRight: '15px' }}
          />
          <div style={{ flex: '1' }}>
            <h4 style={{
              fontSize: '18px',
              fontWeight: 'bold',
              color: Colors.text,
              margin: '0 0 4px'
            }}>{option.name}</h4>
            <span style={{
              fontSize: '16px',
              color: Colors.primary,
              fontWeight: '600'
            }}>
              ${option.price} {option.billing !== 'one-time' && `/${option.billing}`}
            </span>
            {option.billing === 'setup + $200/month' && (
              <p style={{
                fontSize: '12px',
                color: Colors.textSecondary,
                margin: '2px 0 0'
              }}>Setup fee + monthly subscription</p>
            )}
          </div>
        </div>
        
        <p style={{
          fontSize: '14px',
          color: Colors.textSecondary,
          marginBottom: '16px',
          lineHeight: '20px'
        }}>{option.description}</p>
        
        <div style={{ marginBottom: '16px' }}>
          {option.features.map((feature, index) => (
            <div key={index} style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '8px'
            }}>
              <Icon name="chevron-right" size={16} color={Colors.primary} />
              <span style={{
                fontSize: '14px',
                color: Colors.text,
                marginLeft: '8px',
                lineHeight: '20px'
              }}>{feature}</span>
            </div>
          ))}
        </div>

        <button 
          style={{
            padding: '12px 20px',
            borderRadius: '8px',
            border: `1px solid ${Colors.primary}`,
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            textAlign: 'center',
            transition: 'all 0.3s ease',
            backgroundColor: 'transparent',
            color: Colors.primary,
            width: '100%'
          }}
          onClick={handleContactSales}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = Colors.primary;
            e.currentTarget.style.color = Colors.buttonText;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = Colors.primary;
          }}
        >
          Learn More
        </button>
      </div>
    );
  };

  return (
    <>
          <Navbar />
    <div style={{
      backgroundColor: Colors.background,
      minHeight: '100vh',
      color: Colors.text,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif'
    }}>
      <div style={{ paddingBottom: '20px' }}>
        

        {/* Billing Toggle */}
        <div style={{
          display: 'flex',
          backgroundColor: Colors.input,
          borderRadius: '25px',
          margin: '20px auto',
          padding: '4px',
          width: 'fit-content',
          position: 'relative',
          border: `1px solid ${Colors.border}`
        }}>
          <button 
            style={{
              padding: '8px 20px',
              borderRadius: '20px',
              border: 'none',
              backgroundColor: billingCycle === 'monthly' ? Colors.primary : 'transparent',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontSize: '14px',
              fontWeight: '600',
              color: billingCycle === 'monthly' ? Colors.buttonText : Colors.textSecondary
            }}
            onClick={() => setBillingCycle('monthly')}
          >
            Monthly
          </button>
          <button 
            style={{
              padding: '8px 20px',
              borderRadius: '20px',
              border: 'none',
              backgroundColor: billingCycle === 'annual' ? Colors.primary : 'transparent',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontSize: '14px',
              fontWeight: '600',
              color: billingCycle === 'annual' ? Colors.buttonText : Colors.textSecondary
            }}
            onClick={() => setBillingCycle('annual')}
          >
            Annual
          </button>
          {billingCycle === 'annual' && (
            <div style={{
              position: 'absolute',
              top: '-25px',
              right: '0',
              backgroundColor: Colors.success,
              padding: '4px 8px',
              borderRadius: '12px'
            }}>
              <span style={{
                fontSize: '12px',
                color: Colors.text,
                fontWeight: '600'
              }}>Save up to 17%</span>
            </div>
          )}
        </div>

        {/* Individual Practitioner Plans */}
        <div style={{ margin: '100px 0', marginBottom: '10px' }}>
          
          
          <div style={{
            display: 'flex',
            padding: '0 20px',
            gap: '16px',
            overflowX: 'auto',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            {practitionerPlans.map((plan) => (
              <PricingCard 
                key={plan.id}
                plan={plan}
                type="practitioner"
                onSelect={handleSelectPlan}
                onTrial={handleStartTrial}
              />
            ))}
          </div>
        </div>

        

        {/* Enterprise CTA */}
        <div style={{
          backgroundColor: Colors.tile,
          marginRight: '150px',
          marginLeft: '150px',
          marginTop: '0px',
          padding: '30px',
          borderRadius: '16px',
          textAlign: 'center',
          border: `1px solid ${Colors.border}`
        }}>
          
          <p style={{
            fontSize: '16px',
            color: Colors.textSecondary,
            lineHeight: '22px',
            marginBottom: '20px'
          }}>
            
          </p>
          <button 
            style={{
              backgroundColor: Colors.primary,
              color: Colors.buttonText,
              minWidth: '200px',
              padding: '12px 20px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              textAlign: 'center',
              transition: 'all 0.3s ease'
            }}
            onClick={handleContactSales}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 4px 12px ${Colors.primary}40`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Contact Us
          </button>
          <p style={{
            fontSize: '14px',
            color: Colors.textSecondary,
            marginBottom: '8px',
            lineHeight: '20px'
          }}>
            All plans include HIPAA compliance, data encryption, and 99.9% uptime guarantee
          </p>
          <p style={{
            fontSize: '12px',
            color: Colors.textSecondary,
            fontStyle: 'italic',
            margin: 0
          }}>
            30-day free trial • No setup fees • Cancel anytime
          </p>
        </div>

        
      </div>
    </div>
    </>
  );
};

export default ProfessionalPricingScreen;